module.exports = __webpack_public_path__ + "static/media/resend_invitation_success.23d09d07.svg";